var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"py-8 px-15 xl:w-full text-red-primary flex bg-gray-110 border border-solid border-red-primary rounded-6"},[_c('Icon',{staticClass:"flex-none",attrs:{"icon":['fas', 'exclamation-triangle'],"size":16}}),_c('div',{staticClass:"relative inline-block font-bold text-sm top[-1px] ml-8 leading-normal"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }